import * as React from 'react';
import clsx from 'clsx';

type FormLabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

const FormLabel = React.forwardRef<HTMLLabelElement, FormLabelProps>((
    {
        className,
        children,
        htmlFor,
        ...rest
    },
    ref
): React.ReactElement => (
    <label
        ref={ref}
        className={clsx(
            'form-label',
            className
        )}
        htmlFor={htmlFor}
        {...rest}
    >
        {children}
    </label>
));

FormLabel.displayName = 'FormLabel';

export default FormLabel;
